import chat from '../../assets/chat.png';
import edit from '../../assets/edit.svg';
import cancel from '../../assets/x-octagon.svg';
import { useState } from 'react';
import VendorContactPersonModal from './VendorContactPersonModal';
import VendorImageComponent from './VendorImageComponent';

function VendorOverview({ vendorDetails }) {
  const [addressIsVisible, setAddressVisible] = useState(false);
  const [shippingIsVisible, setShippingVisible] = useState(false);
  const [location, setLocation] = useState(false);
  const [otherAddress, setOtherAddress] = useState(false);
  const [customAddress, setCustomAddress] = useState(false);

  const EditIcon = <img src={edit} alt="edit" className="w-4 h-4" />;
  const CancelIcon = <img src={cancel} alt="cancel" className="w-4 h-4" />;

  return (
    <div className="max-w-6xl mx-auto p-4 space-y-6">
      {/* Main Card */}
      <div className="bg-white rounded-xl shadow-lg overflow-hidden">
        {/* Header: Image + Basic Info */}
        <div className="p-6 border-b border-gray-200">
          <div className="flex flex-col sm:flex-row gap-6 items-start">
            <VendorImageComponent imgSrc={vendorDetails?.Vendor_Image_URL} />

            <div className="space-y-1 flex-1">
              <h2 className="text-xl font-bold text-gray-900">{vendorDetails?.Vendor_Full_Name}</h2>
              <p className="text-sm text-gray-600">{vendorDetails?.Vendor_Email_Address}</p>
              <p className="text-sm text-gray-600">{vendorDetails?.Vendor_Mobile_No}</p>
            </div>
          </div>
        </div>

        {/* Financial Summary */}
        <div className="p-6 bg-gray-50 border-b border-gray-200">
          <div className="grid grid-cols-3 gap-6 text-center">
            <div>
              <p className="text-xs text-gray-600">
                Outstanding
                <br />
                Payables
              </p>
              <p className="text-lg font-bold text-gray-900">₦0.00</p>
            </div>
            <div>
              <p className="text-xs text-gray-600">
                Unused
                <br />
                Credits
              </p>
              <p className="text-lg font-bold text-gray-900">₦0.00</p>
            </div>
            <div>
              <p className="text-xs text-gray-600">
                Payment
                <br />
                Due Period
              </p>
              <p className="text-lg font-bold text-gray-900">Payment Terms</p>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-6 text-sm">
            <div>
              Items to be received: <span className="font-bold text-blue-600 ml-1">0</span>
            </div>
            <div>
              Total Items Ordered: <span className="font-bold text-blue-600 ml-1">0</span>
            </div>
          </div>
        </div>

        {/* Address & Details Section */}
        <div className="p-6 space-y-8">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Left Column: Addresses */}
            <div className="space-y-6">
              <h3 className="text-sm font-bold text-blue-600">ADDRESS INFORMATION</h3>

              {/* Billing Address */}
              <div>
                <button
                  onClick={() => setAddressVisible(!addressIsVisible)}
                  className="flex items-center gap-2 text-sm font-semibold hover:text-blue-600 transition"
                >
                  Billing Address
                  {addressIsVisible ? CancelIcon : EditIcon}
                </button>
                {addressIsVisible && (
                  <div className="mt-3 space-y-2 text-sm text-gray-700 pl-6 border-l-2 border-gray-300">
                    <p>
                      <span className="font-medium">Attention:</span> {vendorDetails?.Billing_Attention}
                    </p>
                    <p>
                      <span className="font-medium">Address:</span> {vendorDetails?.Billing_Address1}
                    </p>
                    <p>
                      <span className="font-medium">Address 2:</span> {vendorDetails?.Billing_Address2}
                    </p>
                    <p>
                      <span className="font-medium">Country:</span> {vendorDetails?.Billing_Country_Name}
                    </p>
                    <p>
                      <span className="font-medium">State:</span> {vendorDetails?.Billing_City_Name}
                    </p>
                    <p>
                      <span className="font-medium">Zip Code:</span> {vendorDetails?.Billing_Zip_Code}
                    </p>
                    <p>
                      <span className="font-medium">Area:</span> {vendorDetails?.Billing_Area_Name}
                    </p>
                    <p>
                      <span className="font-medium">Fax:</span> {vendorDetails?.Billing_Fax_Number}
                    </p>
                  </div>
                )}
              </div>

              {/* Shipping Address */}
              <div>
                <button
                  onClick={() => setShippingVisible(!shippingIsVisible)}
                  className="flex items-center gap-2 text-sm font-semibold hover:text-blue-600 transition"
                >
                  Shipping Address
                  {shippingIsVisible ? CancelIcon : EditIcon}
                </button>
                {shippingIsVisible && (
                  <div className="mt-3 space-y-2 text-sm text-gray-700 pl-6 border-l-2 border-gray-300">
                    <p>
                      <span className="font-medium">Attention:</span> {vendorDetails?.Shipping_Attention}
                    </p>
                    <p>
                      <span className="font-medium">Address 1:</span> {vendorDetails?.Shipping_Address1}
                    </p>
                    <p>
                      <span className="font-medium">Address 2:</span> {vendorDetails?.Shipping_Address2}
                    </p>
                    <p>
                      <span className="font-medium">Country:</span> {vendorDetails?.Shipping_Country_Name}
                    </p>
                    <p>
                      <span className="font-medium">State:</span> {vendorDetails?.Shipping_City_Name}
                    </p>
                    <p>
                      <span className="font-medium">Zip Code:</span> {vendorDetails?.Shipping_Zip_Code}
                    </p>
                    <p>
                      <span className="font-medium">Area:</span> {vendorDetails?.Shipping_Area_Name}
                    </p>
                    <p>
                      <span className="font-medium">Fax:</span> {vendorDetails?.Shipping_Fax_Number}
                    </p>
                  </div>
                )}
              </div>

              {/* Location */}
              <div>
                <button
                  onClick={() => setLocation(!location)}
                  className="flex items-center gap-2 text-sm font-semibold hover:text-blue-600 transition"
                >
                  Location
                  {location ? CancelIcon : EditIcon}
                </button>
                {location && (
                  <div className="mt-3 space-y-2 text-sm text-gray-700 pl-6 border-l-2 border-gray-300">
                    <p>
                      <span className="font-medium">Branch:</span> Display Branch
                    </p>
                    <p>
                      <span className="font-medium">API:</span> Display API
                    </p>
                    <p>
                      <span className="font-medium">Latitude:</span> {vendorDetails?.GPS_Latitude}
                    </p>
                    <p>
                      <span className="font-medium">Longitude:</span> {vendorDetails?.GPS_Longitude}
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Right Column: Other Info */}
            <div className="space-y-6">
              <h3 className="text-sm font-bold text-blue-600">OTHER INFORMATION</h3>

              <div className="space-y-2 text-sm text-gray-700">
                <p>
                  <span className="font-medium">Customer ID:</span> {vendorDetails?.Customer_Id}
                </p>
                <p>
                  <span className="font-medium">Customer Type:</span> {vendorDetails?.Customer_Type_Name}
                </p>
                <p>
                  <span className="font-medium">Currency:</span> {vendorDetails?.Currency_Symbol}
                </p>
                <p>
                  <span className="font-medium">Source:</span> API
                </p>
              </div>

              {/* Other Details */}
              <div>
                <button
                  onClick={() => setOtherAddress(!otherAddress)}
                  className="flex items-center gap-2 text-sm font-semibold hover:text-blue-600 transition"
                >
                  Other Details
                  {otherAddress ? CancelIcon : EditIcon}
                </button>
                {otherAddress && (
                  <div className="mt-3 space-y-2 text-sm text-gray-700 pl-6 border-l-2 border-gray-300">
                    <p>
                      <span className="font-medium">Currency:</span> {vendorDetails?.Currency_Name}
                    </p>
                    <p>
                      <span className="font-medium">Payment Terms:</span> {vendorDetails?.Payment_Term_Name}
                    </p>
                    <p>
                      <span className="font-medium">Price List:</span> {vendorDetails?.Price_List_Name}
                    </p>
                    <p>
                      <span className="font-medium">Website:</span> Display Website
                    </p>
                    <p>
                      <span className="font-medium">Facebook:</span> {vendorDetails?.Facebook_URL}
                    </p>
                    <p>
                      <span className="font-medium">Twitter:</span> {vendorDetails?.Twitter_URL}
                    </p>
                    <p>
                      <span className="font-medium">Remark:</span> {vendorDetails?.Customer_Remark}
                    </p>
                  </div>
                )}
              </div>

              {/* Custom Fields */}
              <div>
                <button
                  onClick={() => setCustomAddress(!customAddress)}
                  className="flex items-center gap-2 text-sm font-semibold hover:text-blue-600 transition"
                >
                  Custom Fields
                  {customAddress ? CancelIcon : EditIcon}
                </button>
                {customAddress && (
                  <div className="mt-3 space-y-2 text-sm text-gray-700 pl-6 border-l-2 border-gray-300">
                    <p>
                      <span className="font-medium">Religion:</span> {vendorDetails?.Religion_Name}
                    </p>
                    <p>
                      <span className="font-medium">Bustop:</span> Display Bustop
                    </p>
                    <p>
                      <span className="font-medium">Referred Person:</span> Display Referred Person
                    </p>
                    <p>
                      <span className="font-medium">Date of Birth:</span> Display Date of Birth
                    </p>
                    <p>
                      <span className="font-medium">Age:</span> Display Age
                    </p>
                    <p>
                      <span className="font-medium">Profession:</span> Display Profession
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
    

    
        </div>
      </div>
    </div>
  );
}

export default VendorOverview;
